export const TransactionColKey = {
    number: 'number',
    number_with_link: 'number_with_link', // Report's All Transactions
    type: 'type',
    all_types: 'all_types', // Report's All Transactions
    date: 'date',
    contact_name: 'contact_name',
    contact2_name: 'contact2_name',

    billing_party: 'billing_party',
    shipping_info: 'shipping_info',
    shipping_party: 'shipping_party',
    number2: 'number2',
    title: 'title',
    description: 'description',
    amount: 'amount',
    balance: 'balance',

    invoice_number: 'invoice_number',
    invoice_description: 'invoice_description',

    overpayment: 'overpayment', // Sales/Payments & Purchase/Payments
    payment_account: 'pay_to', // Invoice Payments & Purchase Payments
    deposit_to: 'deposit_to', // Bank/Income
    pay_from: 'deposit_from', // Bank/Expense
    transfer_from: 'transfer_from', // Bank/Transfer
    transfer_to: 'transfer_to', // Bank/Transfer

    payment_method: 'payment_method', // Payment Method

    tag_names: 'tag_names',
    status: 'status',
    invoice_status: 'invoice_status',
    email: 'email',
    transfer: 'transfer',
    files: 'files',

    custom_fields: 'custom_fields', // multi-columns (will be broken down into field_1, field_2, ... field_n)

    created_at: 'created_at',
    created_by: 'created_by',
    action: 'action',
};
